import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { PaginaInicialComponent } from './pagina-inicial/pagina-inicial.component';
import { RecuperarSenhaComponent } from './recuperar-senha/recuperar-senha.component';
import { PPASignificadoComponent } from './ppa-significado/ppa-significado.component';
import { DiretrizesEstadoComponent } from './diretrizes-estado/diretrizes-estado.component';
import { ConhecaMaisComponent } from './conheca-mais/conheca-mais.component';
import { PreCadastroComponent } from './pre-cadastro/pre-cadastro.component';

import { PaginaNaoEncontradaComponent } from 'src/app/Components/pagina-nao-encontrada/pagina-nao-encontrada.component';


const PUBLIC_ROUTES: Routes = [
  {
    path: 'publico',
    component: PaginaInicialComponent,
    children: [
      {
        path: '', redirectTo: 'home', pathMatch: 'full'
      },
      {
        path: 'home', component: LoginComponent
      },
      {
        path: 'login', component: LoginComponent
      },
      {
        path: 'recuperar-senha', component: RecuperarSenhaComponent
      },
      {
        path: 'ppa-significado', component: PPASignificadoComponent
      },
      {
        path: 'diretrizes-estado', component: DiretrizesEstadoComponent
      },
      {
        path: 'conheca-mais', component: ConhecaMaisComponent
      },
      {

        path: 'pre-cadastro', component: PreCadastroComponent
      },
      {
        path: 'pagina-nao-encontrada', component: PaginaNaoEncontradaComponent
      },
      {
        path: '**', component: PaginaInicialComponent

      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(PUBLIC_ROUTES)
  ],
  exports: [
    RouterModule
  ]
})
export class PublicRoutingModule { }
